var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<a ng-click=\"vm.getDocument()\" ng-disabled=\"vm.loading\" ng-class=\"vm.linkclass\" tabindex=\"0\"><span>{{ vm.label }}</span><span ng-if=\"vm.loading\"><i class=\"spinner inline\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></i><span>&nbsp;</span></span></a>");;return buf.join("");
}